import { useTranslation } from '@shared/core/i18n/useTranslation';
import { Box, CheckboxV2, Flex, SpacingStack } from '@withjoy/joykit';
import React, { useState } from 'react';
import { SurveyStepProps } from '../types';
import { NavigationButton } from '../../components/NavigationButton';
import { StepHeader } from '../components/StepHeader';
import { STEP_MINIMUM_HEIGHT } from '../consts';

type RadioSelectProps = {
  isChecked: boolean;
  onChange: () => void;
  id: string;
  children: React.ReactNode;
};

export const RadioSelect = ({ isChecked, onChange, id, children }: RadioSelectProps) => {
  return (
    <Box>
      <CheckboxV2
        isChecked={isChecked}
        onChange={onChange}
        id={id}
        overrides={{
          Control: {
            props: {
              borderRadius: 20,
            },
          },
        }}
      >
        {children}
      </CheckboxV2>
    </Box>
  );
};

export const EventFormAttendanceStep = (props: SurveyStepProps) => {
  const { hasNext, hasPrev, onSubmitNotAttending, onAttending, onBack } = props;

  const { tq } = useTranslation('eventFormDisplay');
  const [attending, setAttending] = useState<boolean | null>(props.formState.attendanceValue);

  const attendanceValid = attending !== null;

  const handleSetAttending = (value: boolean) => {
    setAttending(value);
    props.setFormState({
      ...props.formState,
      attendanceValue: value,
    });
  };

  const handleNext = () => {
    if (attending) {
      onAttending();
    } else {
      onSubmitNotAttending();
    }
  };

  return (
    <Box>
      <SpacingStack gap="1rem">
        <Box minHeight={STEP_MINIMUM_HEIGHT}>
          <StepHeader
            heading={tq`Attendance`}
            subheading={tq`Will you be attending the event?`}
          />
          <SpacingStack alignItems={'flex-start'}>
            <RadioSelect
              isChecked={attending === true}
              onChange={() => handleSetAttending(true)}
              id={'yes'}
            >
              {tq`Yes`}
            </RadioSelect>
            <RadioSelect
              isChecked={attending === false}
              onChange={() => handleSetAttending(false)}
              id={'no'}
            >
              {tq`No`}
            </RadioSelect>
          </SpacingStack>
        </Box>
        <Flex
          marginTop="32px"
          width="100%"
          columnGap="6"
        >
          {hasPrev && (
            <NavigationButton
              onClick={onBack}
              direction="prev"
            />
          )}
          {hasNext && (
            <NavigationButton
              onClick={handleNext}
              direction="next"
              disabled={!attendanceValid}
            />
          )}
        </Flex>
      </SpacingStack>
    </Box>
  );
};
